import wire from '../wire';
import template from './marketing-corner.html';

class MarketingCornerController {
  constructor($rootScope, $http, toaster, ConfirmDialog, MeetingsService) {
    'ngInject';

    this.account = $rootScope.account;
    this.$http = $http;
    this.toaster = toaster;
    this.ConfirmDialog = ConfirmDialog;
    this.MeetingsService = MeetingsService;

    this.user = $rootScope.user;

    this.ff = this.account.feature_flags;
    this.features = [
      {
        name: 'Unlimited Destinations',
        enabled: !this.ff.single_destination,
        info: 'Stream to your website, Facebook Live, YouTube, Twitter, a hosted link, Chromecast, any RTMP destination or your mobile apps.',
      },
      {
        name: 'Analytics',
        enabled: this.ff.analytics,
        info: 'Understand your reach with engagement graphs and data on total views, unique viewers, and average view duration. See where in the world your viewers are watching, with a live interactive map. Take a detailed look at how viewers watch your content with data on viewing destinations, devices, browsers and operating systems, and playback quality',
      },
      {
        name: 'Graphic Overlays',
        enabled: this.ff.overlays,
        info: 'Enhance your broadcast with graphics like logos, watermarks, lower thirds, full screen overlays or basic advertisements.',
      },
      {
        name: 'Ticketing',
        enabled: !this.ff.no_ticketed,
        info: 'Generate revenue by selling tickets to your live or recorded broadcasts. Includes 25% revenue share for viewer support and processing.',
      },
      {
        name: 'Automatic Recording',
        enabled: !this.ff.no_recordings,
        info: 'Let viewers watch the automatically recorded broadcast using the same links and embeds.',
      },
      {
        name: 'Password Protection',
        enabled: this.ff.password,
        info: 'Protect your broadcasts with a single password.',
      },
      {
        name: 'API Access',
        enabled: this.ff.api_keys,
        info: "Customize your video workflow using BoxCast's API.",
      },
      {
        name: 'Stream to Smart TV Apps',
        enabled: this.ff.appletv_roku,
        info: 'Let viewers watch your stream on their Smart TVs using the BoxCast App for Apple TV, Roku, and Amazon Fire TV',
      },
      {
        name: 'Scoreboard Overlays',
        enabled: this.ff.manual_scoreboard,
        info: 'Overlay a live scoreboard on your broadcast. Control the scoreboard on your computer, phone, or tablet or integrate with your onsite scoreboard.',
      },
      {
        name: 'Concurrent Broadcasts',
        enabled: this.account.max_simultaneous_streams != 1,
        info: 'Account for overlapping events by streaming two or more broadcasts simultaneously.',
      },
      {
        name: 'Donations',
        enabled: this.ff.donations,
        info: 'Accept donations for your organization. Includes 6% processing fee.',
      },
      {
        name: 'Automated Captioning',
        enabled: this.ff.automated_captioning,
        info: 'Save time, adhere to compliance standards, and make your recorded broadcasts more accessible by automatically adding closed captions',
      },
      {
        name: 'Multi-Site Player',
        enabled: this.ff.multi_site,
        info: 'Stream to multiple remote campuses in high-quality without buffering.',
      },
      {
        name: 'Highlight Clipping',
        enabled: this.ff.highlights,
        info: 'Capture important moments and share them on social media by quickly clipping highlights mid-broadcast or after your broadcast is over.',
      },
      {
        name: 'Simulated Live',
        enabled: this.ff.simulated_live,
        info: 'Re-broadcast recorded or uploaded broadcasts to any destination.',
      },
      {
        name: 'Geo-Blocking',
        enabled: this.ff.geoblock,
        info: 'Restrict viewership geographically based on zipcode or point and radius.',
      },
      {
        name: 'Embedding Restrictions',
        enabled: this.ff.host_restrictions,
        info: 'Maintain control of your content by limiting the destinations or URLs where the broadcast can be watched.',
      },
      {
        name: 'Video Markers',
        enabled: this.ff.cue_points,
        info: 'Help viewers easily find significant moments by naming and tagging points in a recorded broadcast.',
      },
    ];

    this.additionalOptions = [
      {
        name: 'Additional Concurrent Broadcasts',
        info: 'Account for overlapping events by streaming two or more broadcasts simultaneously.',
      },
      {
        name: 'Custom Smart TV Apps',
        info: 'Let viewers access your streams on your own branded TV app on Apple TV and Roku.',
      },
      {
        name: 'Additional Features',
        info: "We're always listening and looking for ways to improve your experience. Some of our newer features may not be listed here.",
      },
    ];

    this.scheduleTime = () => {
      this.MeetingsService.scheduleMeeting();
    };
  }
}

var module = wire(
  'marketing-corner',
  template,
  MarketingCornerController,
  'MarketingCornerController'
);

export default module;



// WEBPACK FOOTER //
// ./app/pages/marketing-corner/_index.js